import siteGroupsReducer from '@sophocles/features/siteGroups/slice';

export default siteGroupsReducer;
